import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BrowserModule, DomSanitizer,  Meta, Title } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';

//providers
import { SedeProviderService } from '../../../providers/sedes/sede-provider.service';

@Component({
  selector: 'app-estados-financieros',
  templateUrl: './estados-financieros.component.html',
  styleUrls: ['./estados-financieros.component.css']
})
export class EstadosFinancierosComponent implements OnInit {

  public contenido: any = "";
  public urlSede: any = "";
  public estado : any = {};
  constructor( private sedeProvider: SedeProviderService, private router: Router, private activateRoute: ActivatedRoute, private sanitizer: DomSanitizer ) { }



  ngOnInit() {
    this.activateRoute.paramMap.subscribe(
      ( map ) => {
        let that = this;
        that.urlSede = map.get('url');
        that.cargarDatos( that.urlSede );
      }
    );
  }

  /**
   * Obtiene la informacion de la pagina
   *
   * @param String   la url de la sede 'sede/UrlSede'
   */
   cargarDatos( url: any ){
     let urlcompleta = "/"+url;
     let datos = {
      url: urlcompleta,
    }
     this.sedeProvider.estadosFinancieros( datos ).subscribe(
       ( data ) => {
         let that = this;
         that.estado =  data.datos;
         that.cargarContenido( that.estado.textoEstado );
       },
       ( error ) => {
         if( error.status == 500 ){
           console.log( "error en el servidor");
         }
       }
     );
   }

   /**
    * Carga el contenido de la pagina que retorna el servidor
    *
    * @param String   codigo html almacenado en la base de datos
    */
   cargarContenido( contenido ){
     this.contenido = this.sanitizer.bypassSecurityTrustHtml( contenido );
   }

   /**
    * Decodifica el utf8 recibido
    *
    * @param String    texto para decodificar
    */
   decode_utf8(s) {
     try{
         return decodeURIComponent(escape(s));
     }catch(err){
       return s.replace("Ã‰", "É");
     }
   }

}
